import {useEffect} from 'react'
import {Alert, Badge, Button} from 'react-bootstrap'
import PropTypes from 'prop-types'
import ReactJson from 'react18-json-view'
import GenerujPdf from "../GenerujPdf.jsx";

const AlertComponent = (props) => <Alert variant={props.variant}><h5><strong>{props.text}</strong></h5></Alert>
AlertComponent.propTypes = {
    variant: PropTypes.string,
    text: PropTypes.string,
}

const WizardSummary = (props) => {

    const isError = Object.keys(props?.wiz?.summary?.error || {}).length > 0 || Object.keys(props?.wiz?.summary?.dicts_msg?.error || {}).length > 0
    const isWarning = !isError && Object.keys(props?.wiz?.summary?.warning || {}).length > 0 || Object.keys(props?.wiz?.summary?.dicts_msg?.warning || {}).length > 0
    const isSuccess = !isError && !isWarning

    const variant = isError ? 'danger' : isWarning ? 'warning' : isSuccess ? 'success' : 'primary'
    const text = isError ? props.failed : isWarning ? props.warning : isSuccess ? props.success : 'sprawdzamy dane...'
    useEffect(() => {
        if (!props?.wiz?.summary?.error?.length || !props?.wiz?.summary?.warnings?.length) {
            props.wiz.setValidation([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const dictWarnings = Object.keys(
        props?.wiz?.summary?.dicts_msg?.warning || {}
    )
        .map((key) => {

            return {
                key,
                type: 'warning',
                label: props.wiz.getLabel(key),
                msgs: props?.wiz?.summary?.dicts_msg?.warning?.[key],
            }
        })
    const dictErrors = Object.keys(
        props?.wiz?.summary?.dicts_msg?.error || {}
    )
        .map((key) => {

            return {
                key,
                type: 'danger',
                label: props.wiz.getLabel(key),
                msgs: props?.wiz?.summary?.dicts_msg?.error?.[key],
            }
        })


    return (
        <>
            {<AlertComponent variant={variant} text={text}/>}


            {props.wiz.mapping.map((p, idx) => {
                const pageErrors = Object.keys(props?.wiz?.summary?.error || {})
                    .filter((key) => {
                        if (props.wiz.stateForPage) {
                            return key.startsWith(p.name)
                        } else {
                            // return p.fields.map((f) => f.name).includes(key.split('.')[1])
                            return p.fields.map((f) => f.name).includes(key.split('.')[0])
                        }
                    })
                    .map((key) => {
                        const k = key.replace(p.name + '.', '')
                        return {
                            key: k,
                            type: 'error',
                            label: props.wiz.getLabel(k, p.name),
                            msgs: props?.wiz?.summary?.error?.[key],
                            row: key
                                .split('.')
                                .filter((n) => /^\d+$/.test(n))
                                .map((n) => parseInt(n) + 1)
                                .join('->'),
                        }
                    })

                const pageWarnings = Object.keys(
                    props?.wiz?.summary?.warning || {}
                )
                    .filter((key) => {
                        if (props.wiz.stateForPage) {
                            return key.startsWith(p.name)
                        } else {
                            // return p.fields.map((f) => f.name).includes(key)
                            return p.fields.map((f) => f.name).includes(key.split('.')[0])

                        }
                    })
                    .map((key) => {
                        const k = key.replace(p.name + '.', '')
                        return {
                            key: k,
                            type: 'warning',
                            label: props.wiz.getLabel(k, p.name),
                            msgs: props?.wiz?.summary?.warning?.[key],
                            row: key
                                .split('.')
                                .filter((n) => /^\d+$/.test(n))
                                .map((n) => parseInt(n) + 1)
                                .join('->'),
                        }
                    })


                return (
                    <div
                        key={idx + p.name}
                        style={{
                            display: (pageErrors.length > 0 || pageWarnings.length > 0) ? 'block' : 'none',
                            textAlign: 'left',
                        }}
                        className={'mt-4'}
                    >
                        <h4 key={idx + p.name}>
                            <strong key={idx + p.name}>
                                {p?.label || `brak mapowania (${p?.name})`}
                            </strong>
                            <Button
                                as={'a'}
                                className={'ms-2'}
                                onClick={() => {
                                    props.wiz.setValidation([
                                        ...pageErrors,
                                        ...pageWarnings,
                                        // ...dictErrors,//////////////////////////////////////////////
                                        // ...dictWarnings,//////////////////////////////////////////////
                                    ])
                                    props.wiz.setPageByName(p?.name)
                                }}
                            >
                                Idź do strony
                            </Button>
                        </h4>

                        {window.debug && <ReactJson src={pageErrors} collapsed={true}/>}


                        {[...pageErrors, ...pageWarnings

                            .filter(w => pageErrors.find(e => e.key === w.key)?.key !== w.key)] //@ wyklucz z wyświetlania te warningi, które są już w errorach
                            .map((e, idx) => {
                                return <Alert
                                    className={'p-2'}
                                    key={e.key + idx}
                                    variant={
                                        e.type === 'error' ? 'danger' : 'warning'
                                    }
                                >
                                    <div key={idx + p.name}>
                                        {e.label !== 'ID' ? 'Pole: ' : ''}

                                        {e.label === 'ID' ? <Badge bg={'danger'}>Błąd poprawności: </Badge> :
                                            <strong>{e.label}</strong>}
                                        {e.label !== 'ID' ? <Button
                                            variant={'secondary'}
                                            className={'ms-2'}
                                            onClick={() => {
                                                props.wiz.setValidation([
                                                    ...pageErrors,
                                                    ...pageWarnings,
                                                ])
                                                props.wiz.setPageByName(
                                                    p?.name,
                                                    `${p?.name}.${e.key}`
                                                )
                                            }}
                                            size='sm'
                                        >
                                            Idź do pola
                                        </Button> : ''}
                                    </div>
                                    {e.row && (
                                        <div>
                                            Pozycja: <strong>{e.row}</strong>
                                        </div>
                                    )}

                                    {e.msgs?.map((msg, idx) => {
                                        return <div key={idx}>
                                            <div key={idx + p.name}>
                                                Komunikat: <strong>{msg}</strong>
                                            </div>

                                        </div>
                                    })}
                                </Alert>
                            })}


                    </div>
                )
            })}
            {[...dictErrors, ...dictWarnings]?.length > 0 && <><h4 className={'mt-4'}><strong>Błędy lub ostrzeżenia
                dotyczące słowników:</strong>
            </h4>
                {[...dictErrors, ...dictWarnings]
                    .map((e, idx) => {
                        return <Alert
                            className={'p-2'}
                            key={e.key + idx}
                            variant={e.type}
                        >
                            <div key={idx}>
                                Słownik: <strong>{e.label}</strong>
                            </div>

                            {e.msgs?.map((msg, idx) => (
                                <div key={idx}>
                                    Komunikat: <strong>{msg}</strong>
                                </div>
                            ))}
                        </Alert>
                    })}</>}
            {props.pdfButton && <GenerujPdf
                wiz={props.wiz}
                pdfBodyData={props.pdfBodyData}
                module={props.module}

            />}

        </>
    )
}


WizardSummary.propTypes = {
    loading: PropTypes.any.isRequired,
    failed: PropTypes.any.isRequired,
    success: PropTypes.any.isRequired,
    warning: PropTypes.any,
    wiz: PropTypes.object.isRequired,
    pdfButton: PropTypes.bool,
    pdfBodyData: PropTypes.object,//dane do wygenerowania pdfa
    module: PropTypes.string,//nazwa modułu do wydruku pdfa

}

export default WizardSummary
